import { useSuspenseQuery } from '@tanstack/react-query';

import { tariffQueryOptions } from '../data-provider';

export const useSuspenseTariff = (tariffKey: number) => {
  return useSuspenseQuery(tariffQueryOptions(tariffKey));
};
